import { render, staticRenderFns } from "./ProductLabelYear.vue?vue&type=template&id=d7269b12&"
import script from "./ProductLabelYear.vue?vue&type=script&lang=js&"
export * from "./ProductLabelYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports